// РИСУНОК ЗАГЛУШЕК — перенос генератора борда CD `Life Map - Stub Screens v2.html` (дроп
// `drop-stubs-30-09/`, принят Кириллом 30.09; тикет `3eb19875cbb881bb9a04e503ee488d31`).
//
// Словарь тизера шага 1: три ghost-слоя, амбер 1.1, заливка, растворённые края. Числа — байт борда
// (`yAt`, `pth`, фазы и сдвиги слоёв, доли обрыва). Здесь только геометрия: строки путей и точка.
// Два вида: `crashArt` (падение, линия обрывается) и `lostArt` (404, след растворяется).
// Движение и вид — `wizard-stubs.css`, разметка — `StubScreen.jsx`.
//
// ⚠️ ОТЛИЧИЕ ОТ БОРДА ОДНО, И ОНО В ДВИЖЕНИИ, НЕ В ГЕОМЕТРИИ. Борд меряет длину линии
// `getTotalLength()` в `requestAnimationFrame` и ставит её в `stroke-dasharray`. Здесь путь несёт
// `pathLength="1"`, и прорисовка идёт от 1 к 0 — тот же кадр без замера в браузере (и без падения
// в jsdom, где `getTotalLength` нет).

/** Высота линии в точке x — формула борда. */
export function yAt(x, W, H, ph) {
  const t = x / W;
  return H * 0.52 - H * 0.2 * Math.sin(t * Math.PI * 1.7 + ph) - H * 0.09 * Math.sin(t * Math.PI * 4.1 + ph * 1.6);
}

/** Ломаная от x0 до x1 — шаг ~6 единиц, не меньше 12 отрезков (борд). */
export function pth(W, H, x0, x1, ph, dy = 0) {
  let d = '';
  const n = Math.max(12, Math.round((x1 - x0) / 6));
  for (let i = 0; i <= n; i++) {
    const x = x0 + ((x1 - x0) * i) / n;
    const y = yAt(x, W, H, ph) + dy;
    d += (i ? 'L' : 'M') + x.toFixed(1) + ' ' + y.toFixed(1);
  }
  return d;
}

/** Три ghost-слоя: фаза, сдвиг по вертикали; задержка входа 0.1 + i·0.12 с. */
export const GHOSTS = [[0.6, -3], [1.4, 4], [2.3, -1]];

const PH = 1.0;

/**
 * Экран падения: амбер-линия прорисовывается и обрывается на 58 %; после разрыва — бледный
 * пунктир ниже; на обрыве точка (дышит в CSS).
 * @param {number} W ширина viewBox
 * @param {number} H высота viewBox
 */
export function crashArt(W, H) {
  const bx = W * 0.58;
  const gap = Math.max(14, W * 0.028);
  const drop = H * 0.07;
  const a = pth(W, H, 0, bx, PH, 0);
  return {
    ghosts: GHOSTS.map(([p, dy]) => pth(W, H, 0, W, p, dy)),
    fill: `${a}L${bx} ${H}L0 ${H}Z`,
    line: a,
    tail: pth(W, H, bx + gap, W, PH, drop),
    dot: { cx: bx, cy: yAt(bx, W, H, PH) },
  };
}

/** Затухание следа 404 по x (доля ширины → непрозрачность амбера) — стопы градиента борда. */
export const LOST_FADE = [[0, 1], [0.38, 1], [0.62, 0]];

/**
 * Экран 404: амбер-линия идёт слева полным весом до 40 %, дальше пунктиром до 70 %, и весь след
 * гаснет градиентом 38 → 62 % — к краю остаются только ghost-слои («следа нет, местность есть»).
 * Точки нет. Заливка до 70 %, гаснет маской 35 → 60 % (css).
 * @param {number} W ширина viewBox
 * @param {number} H высота viewBox
 */
export function lostArt(W, H) {
  const end = W * 0.7;
  const a = pth(W, H, 0, end, PH, 0);
  return {
    ghosts: GHOSTS.map(([p, dy]) => pth(W, H, 0, W, p, dy)),
    fill: `${a}L${end} ${H}L0 ${H}Z`,
    line: pth(W, H, 0, W * 0.4, PH, 0),
    tail: pth(W, H, W * 0.4, end, PH, 0),
    fade: LOST_FADE,
  };
}
